// =============================================================================
// useIsAdmin — prosty admin check (whitelist email)
// =============================================================================
// Uzywany przez AdminRoute i komponenty ograniczone do adminow (costs page).

import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const ADMIN_EMAILS = new Set<string>([
  "cesarzdarek@gmail.com",
]);

export function useIsAdmin() {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (cancelled) return;
        setIsAdmin(!!user?.email && ADMIN_EMAILS.has(user.email));
      } catch {
        if (!cancelled) setIsAdmin(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { isAdmin, loading: isAdmin === null };
}
